import { forwardRef } from "react";
import displaysImg from "@/assets/displays.png";

const DisplaysShowcase = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} className="py-20 bg-muted/30 border-y border-border">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="flex justify-center">
          <img
            src={displaysImg}
            alt="Index Rerum em diferentes dispositivos — desktop, tablet e mobile"
            className="w-full max-w-3xl h-auto"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
});

DisplaysShowcase.displayName = "DisplaysShowcase";

export default DisplaysShowcase;
